import {debounce} from '@mui/material/utils'
import axios from 'axios'
import React, {createContext, useContext, useMemo} from 'react'

export const useApiService = () => {
   const context = useContext(ApiServiceContext)

   if (context === null) {
      throw new Error('ApiServiceContext was not provided. Make sure your component is a child of the ApiService')
   }

   return context
}

const ApiServiceContext = createContext(null)

export const InstitutionAutocompleteApi = ({
   children,
   relativePath
}) => {
   const search = useMemo(
      () => {
         return debounce((filter, callback) => {
            const endPoint = `${relativePath}/api/authorizedUsers/search`

            return axios.post(endPoint, {filter})
               .then(({data}) => {
                  return callback(data)

               })
               .catch((error) => {
                  errorAlert(error)
               })
         }, 400)
      },
      []
   )

   const errorAlert = (error) => {
      console.error(error)

      alert('Please try again. If problems persist, contact IT.')
   }

   const apiService = {
      search,
   }

   return <ApiServiceContext.Provider value={apiService}>
      {children}
   </ApiServiceContext.Provider>
}
